// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-2421897d] .orange-icon {\r\n  font-size: 18pt;\n}\n[data-v-2421897d] .custom-datetime-picker-container {\r\n  width: 100% !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
